import { useNavigate } from 'react-router-dom';
import { WarrantyDetailPage as SharedWarrantyDetailPage } from '@/features/warranties/components/WarrantyDetailPage';

export const WarrantyDetailPage = () => {
  const navigate = useNavigate();
  return (
    <div className="tw-pt-4">
      <SharedWarrantyDetailPage embedded onBack={() => navigate(-1)} />
    </div>
  );
};
